/**
 * @desc 문자열이 한글이나 영어로 시작하는지 여부를 판단한다.
 * @param {string} str 문자열
 * @returns {boolean} 검사 결과
 */
export const isStartWithKoEn = (str: string): boolean => {
  const koEnRegex = /^[ㄱ-ㅎ|가-힣|a-z|A-Z]/;
  return koEnRegex.test(str);
};
